import Login from './login'
export default Login
